import { useEffect } from 'react';
import { message } from 'antd';

export const useCloseAntMessage = () => {
	useEffect(() => {
		const handleDocumentClick = (e: MouseEvent) => {
			const messageContainer = document.querySelector('.ant-message') as HTMLElement;
			if (messageContainer && !messageContainer.contains(e.target as Node)) {
				message.destroy();
			}
		};

		document.addEventListener('click', handleDocumentClick);

		return () => {
			document.removeEventListener('click', handleDocumentClick);
		};
	}, []);
};
